import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/recommendation/base';
import type { Course } from '@/models/catalog/course';

export enum RecommendationProcessingStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

interface UseCourseRecommendationsResponse {
  'home/main': {
    courses: Course[];
    id: number;
    processing_status: RecommendationProcessingStatus;
  };
}

interface UseCourseRecommendationsProps {
  profileId?: number;
  enabled?: boolean;
}

export const useCourseRecommendations = ({
  profileId,
  enabled = true,
}: UseCourseRecommendationsProps) => {
  const enabledQuery = enabled !== false && !!profileId;

  const result = useQuery<UseCourseRecommendationsResponse>({
    queryKey: [clientKeys.useCourseRecommendations, profileId],
    queryFn: async () =>
      await falconClient.get(
        `${baseUrl}/profiles/${profileId}/course_recommendations`
      ),
    enabled: enabledQuery,
  });

  return {
    recommendations: result.data?.['home/main']?.courses ?? [],
    id: result.data?.['home/main']?.id,
    processingStatus: result.data?.['home/main']?.processing_status,
    ...result,
  };
};
